import { Injectable } from '@angular/core';
import { BaseApiService } from '@ep/shared';
import { catchError, Observable, of } from 'rxjs';

export interface CreateDeviceRequest {
  Name: string;
  AuthorizationCode: string;
  LocationId?: number;
}

export interface CreateDevicePreRegistrationRequest {
  Name: string;
  SerialNumber: string;
  LocationId?: number;
}

export interface UpdateDeviceNameRequest {
  Name: string;
}

export interface UpdateDeviceAuthorizationCodeRequest {
  AuthorizationCode: string;
}

export interface UpdateDevicePreRegistrationRequest {
  SerialNumber: string;
}

@Injectable({
  providedIn: 'root',
})
export class DeviceService extends BaseApiService {
  private readonly deviceEndpoint = `/v2/Devices`;

  findByMerchantId(merchantId: number): Observable<any> {
    return this.get(`${this.deviceEndpoint}/merchant/${merchantId}`).pipe(
      catchError((err) => {
        console.error(err);
        return of(null);
      })
    );
  }

  findByIdAndMerchantId(deviceId: number, merchantId: number): Observable<any> {
    return this.get(`${this.deviceEndpoint}/${deviceId}/merchant/${merchantId}`).pipe(
      catchError((err) => {
        console.error(err);
        return of(null);
      })
    );
  }

  create(merchantId: number, createDeviceRequest: CreateDeviceRequest): Observable<any> {
    return this.post(`${this.deviceEndpoint}/merchant/${merchantId}`, createDeviceRequest);
  }

  createPreRegistration(
    merchantId: number,
    createDevicePreRegistrationRequest: CreateDevicePreRegistrationRequest
  ): Observable<any> {
    return this.post(
      `${this.deviceEndpoint}/merchant/${merchantId}/pre-registration`,
      createDevicePreRegistrationRequest
    );
  }

  update(deviceId: number, merchantId: number, updateDeviceNameRequest: UpdateDeviceNameRequest): Observable<any> {
    return this.patch(`${this.deviceEndpoint}/${deviceId}/merchant/${merchantId}`, updateDeviceNameRequest).pipe(
      catchError((err) => {
        console.error(err);
        return of(null);
      })
    );
  }

  updateAuthorizationCode(
    deviceId: number,
    merchantId: number,
    updateDeviceAuthorizationCodeRequest: UpdateDeviceAuthorizationCodeRequest
  ): Observable<any> {
    return this.patch(
      `${this.deviceEndpoint}/${deviceId}/merchant/${merchantId}/authorization-code`,
      updateDeviceAuthorizationCodeRequest
    );
  }

  updatePreRegistration(
    deviceId: number,
    merchantId: number,
    updateDevicePreRegistrationRequest: UpdateDevicePreRegistrationRequest
  ): Observable<any> {
    return this.put(
      `${this.deviceEndpoint}/${deviceId}/merchant/${merchantId}/pre-registration`,
      updateDevicePreRegistrationRequest
    );
  }

  deletePreRegistration(deviceId: number, merchantId: number): Observable<any> {
    return this.delete(`${this.deviceEndpoint}/${deviceId}/merchant/${merchantId}/pre-registration`);
  }
}
